import { render, staticRenderFns } from "./JugadoresDetails.vue?vue&type=template&id=6d07da3e"
import script from "./JugadoresDetails.vue?vue&type=script&lang=js"
export * from "./JugadoresDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports